import script from "./InfoPreparingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoPreparingPage.vue?vue&type=script&setup=true&lang=ts"

import "./InfoPreparingPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__